module.exports = __webpack_public_path__ + "static/media/trim-hq-o.fc9cea16.png";